module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.status != null),
      expression: "status != null"
    }],
    staticClass: " container alert status-box",
    class: {
      'alert-success': _vm.status, 'alert-danger': !_vm.status
    },
    attrs: {
      "role": "alert"
    }
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "aria-label": "Close"
    },
    on: {
      "click": _vm.resetStatus
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col media"
  }, [_c('div', {
    staticClass: "d-flex mr-2 status-icon"
  }, [_c('i', {
    staticClass: "fa",
    class: {
      'fa-check': _vm.status, 'fa-exclamation-circle': !_vm.status
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "media-body"
  }, [(_vm.title) ? _c('h5', {
    staticClass: "mt-0"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.message) + " ")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17461132!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assets/Status.vue
// module id = 362
// module chunks = 0